module.exports = __webpack_public_path__ + "static/media/compound4.38dca50e.jpg";